import { Controller } from "@hotwired/stimulus"

// Fills a Bewirtung participant row from a picked customer contact person.
// Listens for the `autocomplete.change` event bubbling up from the nested
// autocomplete widget and copies the selected option's data attributes into the
// row's name/company fields and the customer_id/contact_person_id hidden fields.
export default class extends Controller {
  static targets = ["name", "company", "customerId", "contactPersonId"]

  fill(event) {
    const option = event.detail?.selected
    if (!option) return

    this.setValue(this.nameTarget, option.dataset.name)
    this.setValue(this.companyTarget, option.dataset.company)
    this.setValue(this.customerIdTarget, option.dataset.customerId)
    this.setValue(this.contactPersonIdTarget, event.detail.value)
  }

  // Clearing the picker input drops the link so a stale customer/contact is
  // never persisted alongside a hand-typed name.
  onInput(event) {
    if (event.target.value.trim() !== "") return

    this.clearValue(this.customerIdTarget)
    this.clearValue(this.contactPersonIdTarget)
  }

  setValue(target, value) {
    if (target) target.value = value ?? ""
  }

  clearValue(target) {
    if (target) target.value = ""
  }
}
